module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_2.f8ca94e8.mp3";